import React, { lazy } from 'react';
import { Users } from 'lucide-react';
type Partner = {
  name: string;
  url: string;
  domain: string;
};
const partners: Partner[] = [{
  name: 'National Life Group',
  url: 'https://www.nationallife.com',
  domain: 'nationallife.com'
}, {
  name: 'F&G',
  url: 'https://www.fglife.com',
  domain: 'fglife.com'
}, {
  name: 'Americo',
  url: 'https://www.americo.com',
  domain: 'americo.com'
}, {
  name: 'Mutual of Omaha',
  url: 'https://www.mutualofomaha.com',
  domain: 'mutualofomaha.com'
}, {
  name: 'American Amicable',
  url: 'https://www.americanamicable.com',
  domain: 'americanamicable.com'
}, {
  name: 'Transamerica',
  url: 'https://www.transamerica.com',
  domain: 'transamerica.com'
}, {
  name: 'Ethos',
  url: 'https://www.ethoslife.com',
  domain: 'ethoslife.com'
}];
export function Partners() {
  return <section className="bg-brand-navy py-16" aria-labelledby="partners-title" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        {/* Families stat */}
        <div className="flex flex-col items-center text-center mb-16" data-id="element-136">
          <div className="w-14 h-14 rounded-full bg-brand-green/20 border border-brand-green/30 flex items-center justify-center mb-5" data-id="element-137">
            <Users className="w-7 h-7 text-brand-green" aria-hidden="true" data-id="element-138" />
          </div>
          <p className="text-5xl md:text-6xl font-bold text-white tracking-tight" data-id="element-139">
            +2,500
          </p>
          <p className="text-lg md:text-xl text-gray-300 mt-2" data-id="element-140">
            familias asesoradas y protegidas
          </p>
        </div>

        {/* Partners */}
        <div className="text-center" data-id="element-141">
          <h2 id="partners-title" className="text-sm font-semibold uppercase tracking-widest text-gray-400 mb-10" data-id="element-142">
            Nuestros Partners
          </h2>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-10 md:gap-x-16" data-id="element-143">
            {partners.map(partner => <a key={partner.name} href={partner.url} target="_blank" rel="noopener noreferrer" aria-label={`Visitar el sitio de ${partner.name}`} title={partner.name} className="group flex items-center justify-center h-10 md:h-12 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green rounded" data-id="element-144">
                <img src={`https://logo.clearbit.com/${partner.domain}?size=200`} alt={`Logo de ${partner.name}`} loading="lazy" className="max-h-full w-auto object-contain brightness-0 invert opacity-70 group-hover:opacity-100 transition-opacity" onError={e => {
              // Fallback to the partner name if the logo fails to load
              const img = e.currentTarget;
              const fallback = img.nextElementSibling as HTMLElement | null;
              img.style.display = 'none';
              if (fallback) fallback.style.display = 'inline';
            }} data-id="element-145" />
                <span className="hidden text-white font-semibold text-lg md:text-xl tracking-tight opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-146">
                  {partner.name}
                </span>
              </a>)}
          </div>
        </div>
      </div>
    </section>;
}